import { useLocation, useNavigate } from 'react-router-dom';
import { useI18n } from '../../i18n/LanguageContext';
import { buildLandingPathForMarket, type LandingMarket } from './regional';

type LandingLanguage = 'en' | 'es';

export default function LanguageToggle({
    locale,
    market,
    basePath,
}: {
    locale: LandingLanguage;
    market: LandingMarket;
    basePath: string;
}) {
    const navigate = useNavigate();
    const location = useLocation();
    const { setLanguage } = useI18n();

    const selectLanguage = (target: LandingLanguage) => {
        if (target === locale) return;
        setLanguage(target);

        // A stale ?lang= param would immediately override the new selection,
        // and the /es market prefix forces Spanish regardless of language state.
        const params = new URLSearchParams(location.search);
        params.delete('lang');
        const query = params.toString();
        const targetPath = target === 'en' && market !== 'default'
            ? buildLandingPathForMarket(basePath, 'default')
            : `${location.pathname}`;
        const targetUrl = query ? `${targetPath}?${query}` : targetPath;
        if (targetUrl !== `${location.pathname}${location.search}`) {
            navigate(targetUrl);
        }
    };

    return (
        <div className="nav-lang-toggle" role="group" aria-label={locale === 'es' ? 'Idioma' : 'Language'}>
            <button
                type="button"
                className={locale === 'en' ? 'active' : ''}
                aria-pressed={locale === 'en'}
                onClick={() => selectLanguage('en')}
            >
                EN
            </button>
            <button
                type="button"
                className={locale === 'es' ? 'active' : ''}
                aria-pressed={locale === 'es'}
                onClick={() => selectLanguage('es')}
            >
                ES
            </button>
        </div>
    );
}
